import { render } from "./PropertyOwnership.vue?vue&type=template&id=18622c6a"
import script from "./PropertyOwnership.vue?vue&type=script&lang=js"
export * from "./PropertyOwnership.vue?vue&type=script&lang=js"

import "./PropertyOwnership.vue?vue&type=style&index=0&id=18622c6a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__